// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"6f04a63c","921":"79f0a10e"}[chunkId] + ".chunk.js";
};